import { Modal } from "@mui/material";
import Form from "./form";
import React, { useContext } from "react";
import useListNft from "../../hooks/useListNft";
import { encodeListUrl } from "../../utils/format.utils";
import { assetContent } from "../../store/reducers/asset";
import { useAppSelector } from "../../hooks";
import { ethers } from "ethers";
import useCryptography from "../../hooks/useCryptography";
import { marketplaceContext } from "../../contexts/MarketplaceContext/index";
import { useWhiteboardWebsocket } from "../../hooks/useWhiteboardWebsocket";
import { useDMWebsocket } from "../../hooks/useDMWebsocket";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  assetstatus: assetContent;
  targetPubkey?: Uint8Array;
  lowerCaseToAddress?: string;
}
const NftListModal = ({
  isOpen,
  onClose,
  assetstatus,
  targetPubkey,
  lowerCaseToAddress,
}: Props) => {
  const { listNFT, hashOrder, checkAssetChainId } = useListNft();
  const { currentAddress } = useAppSelector((state) => state.auth);
  const { generateMessage } = useCryptography();
  const { currencyList, chainId } = useContext(marketplaceContext);
  const { handleNewList } = useWhiteboardWebsocket();
  const { sendDMListing } = useDMWebsocket();

  const list = async (nftPrice: any, currency: any, expired: any) => {
    expired = new Date(expired).getTime() / 1000;
    const ADDRESS_ZERO = "0x0000000000000000000000000000000000000000";
    const now = Math.round(new Date().getTime() / 1000);
    let currencyType = "";
    let currencyAmount = null;
    let toAddress = "";
    if (lowerCaseToAddress === undefined || lowerCaseToAddress === null) {
      toAddress = ADDRESS_ZERO;
    } else {
      toAddress = lowerCaseToAddress;
    }
    if (currency == ADDRESS_ZERO) {
      currencyType = "NATIVE";
      currencyAmount = ethers.utils.parseEther(nftPrice.toString()).toString();
    } else if (currency == currencyList.USDC_CONTRACT) {
      currencyType = "ERC20";
      currencyAmount = ethers.utils
        .parseUnits(nftPrice.toString(), 6)
        .toString();
    } else {
      currencyType = "ERC20";
      currencyAmount = ethers.utils.parseEther(nftPrice.toString()).toString();
    }
    const OrderMethod = {
      SELL: 0,
      BUY: 1,
    };
    const ItemType: any = {
      NATIVE: 0,
      ERC20: 1,
      ERC721: 2,
      ERC1155: 3,
    };
    const offerItems = [
      {
        itemType: ItemType[assetstatus.itemType],
        token: assetstatus.assetContract,
        tokenId: ethers.BigNumber.from(assetstatus.tokenId).toLocaleString(),
        tokenAmount: 1,
        recipient: ADDRESS_ZERO,
      },
    ];
    const calculationItem = [
      {
        itemType: ItemType[currencyType],
        token: currency,
        tokenId: 0,
        tokenAmount: currencyAmount,
        recipient: currentAddress,
      },
    ];
    const sale = {
      offerer: currentAddress,
      taker: toAddress,
      method: OrderMethod.SELL,
      offerItems: offerItems,
      calculationItem: calculationItem,
      startTime: now - 100,
      endTime: parseInt(expired),
      salt: 1,
      counter: 0,
    };
    try {
      console.log("list tx start");
      let sign = await listNFT(sale);
      let hash = await hashOrder(sale);
      let chainId = checkAssetChainId(assetstatus);
      console.log("after chainId: ", chainId);
      console.log("list tx finish");
      if (toAddress != ADDRESS_ZERO) {
        submitDmNewList(
          encodeListUrl(
            `${assetstatus.imageUrl},${assetstatus.permalink}`,
            ethers.utils.parseEther(nftPrice.toString()).toString()
          ),
          sale,
          sign,
          hash["detail"],
          chainId
        );
      } else {
        handleNewList(
          encodeListUrl(
            `${assetstatus.imageUrl},${assetstatus.permalink}`,
            ethers.utils.parseEther(nftPrice.toString()).toString()
          ),
          sale,
          sign,
          hash["detail"],
          chainId
        );
      }
    } catch (error) {
      console.log("list tx error");
      throw error;
    } finally {
      console.log("list tx end");
    }
  };
  const submitDmNewList = (
    plaintextMessage: any,
    data: any,
    sign: any,
    hash: any,
    chainId: any
  ) => {
    const message = generateMessage(
      plaintextMessage,
      targetPubkey,
      lowerCaseToAddress
    );
    sendDMListing(message, data, sign, hash, chainId);
  };

  return (
    <Modal
      onClose={onClose}
      open={isOpen}
      style={{
        background: "#111111dd",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Form handleClose={onClose} list={list} assetstatus={assetstatus} />
    </Modal>
  );
};

export default NftListModal;
